import { MappableModel } from './mappable-model'

export class ProfileImage extends MappableModel {
  public image_type: string
  public url: string
}
